module.exports = __webpack_public_path__ + "img/icon_taocan@2x.f35cc25f.png";